import { cn } from 'src/helpers/style'

import { InputText } from 'src/components/atoms'

export interface ISearchBarProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  name?: string
  className?: string
  ariaLabel?: string
}

const CONTAINER_CLASSES =
  '!h-11 !my-0 !rounded-full !border-[0.5px] !border-border focus-within:!border-content-secondary !bg-surface-raised !px-5'

const INPUT_CLASSES =
  '!bg-transparent !p-0 !text-base md:!text-[13px] leading-[1.55] text-content-primary placeholder:!text-base md:placeholder:!text-[13px] placeholder:font-normal placeholder:leading-[1.55] placeholder:text-content-tertiary'

export const SearchBar = ({
  value,
  onChange,
  placeholder,
  name = 'search',
  className,
  ariaLabel,
}: ISearchBarProps): JSX.Element => (
  <InputText
    name={name}
    value={value}
    onChange={event => onChange(event.target.value)}
    placeholder={placeholder}
    aria-label={ariaLabel}
    containerClassName={cn(CONTAINER_CLASSES, className)}
    className={INPUT_CLASSES}
  />
)
